import VerificationEmailInput from './VerificationEmailInput';
import VerificationEmailInputContainer from './VerificationEmailInput.container';
export default VerificationEmailInputContainer(VerificationEmailInput);
